export default __webpack_public_path__ + "static/media/denise-jans-HoqYAnwR-1g-unsplash.043d9e3e.jpg";